// @unocss-include
const layout = () => import('@/layout/index.vue')
const routes = [
  {
    path: '/user',
    name: 'UserManage',
    component: layout,
    redirect: '/user/index',
    meta: {
      title: '用户',
      roles: [0, 2]
    },
    sort: 1,
    children: [
      {
        path: 'index',
        name: 'UserManageIndex',
        component: () => import('@/views/Manage/User.vue'),
        meta: {
          title: '用户管理',
          icon: 'i-tabler:user-hexagon',
          roles: [0, 2]
        }
      }
    ]
  }
]
export default routes
